import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../../cfet-core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customer-verification-notrequired-utf',
    templateUrl: './customer-no-verification-required-utf.component.html',
    styleUrls: ['./customer-no-verification-required-utf.component.scss'],
    standalone: false
})
export class CustomerNoVerificationRequiredUtfComponent extends CfetBaseComponent implements OnInit {
  orgname: any;
  @Output() showCancelModal = new EventEmitter<any>();
  @Output() clearTimeout = new EventEmitter<any>(false);

  constructor(private router: Router) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
    if (sessionStorage.getItem('orgName') && Object.keys(sessionStorage.getItem('orgName').length > 0)) {
      this.orgname = JSON.parse(sessionStorage.getItem('orgName')).orgname;
    }
  }

  completeProfile(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.clearTimeout.emit(true);
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PROFILE_UTF]);
    }
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

}
